import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "ProductDetailAdd" })
export default class ProductDetailAdd extends Vue {
    public localizer: any = Localizer;
    public validationErrors: any[] = [];
    public isLoading: boolean = false;
    public additionalInfo: string = null;
    public quantity: any = 1;
    public maxQuantity: number = 100;

    @Prop() readonly product: any;

    get routes() {
        return (<any>window).App.routes;
    }

    public created() {
        GTagHelper.sendCustomEvent("view_item", {
            currency: "EUR",
            value: this.product.discountPrice ? this.product.discountPrice : this.product.price,
            items: [
                {
                    item_id: this.product.code,
                    item_name: this.product.title,
                    affiliation: "ML Engraving",
                    currency: "EUR",
                    item_category: this.product.categoryName,
                    price: this.product.price,
                    discount: this.product.discountPrice ? this.product.price - this.product.discountPrice : 0
                }
            ]
        });

        this.additionalInfo = <string>this.$route.query.texturecode != null ? <string>this.$route.query.texturecode : null;

        this.maxQuantity = this.product.isDigital ? 1 : 100;
    }

    public addQuantity() {
        this.quantity ? this.quantity++ : this.quantity = 1;

        if (this.quantity > this.maxQuantity) {
            this.quantity = this.maxQuantity;
        }
    }

    public removeQuantity() {
        this.quantity > 1 ? this.quantity-- : this.quantity = 1;
    }

    public async getCart() {
        this.$store.dispatch("cartStore/getCart");
    }

    public async addProduct() {
        FormHelper.removeFocus();
        this.isLoading = true;
        this.validationErrors = [];

        if (isNaN(this.quantity) || this.quantity === "") {
            this.validationErrors.push({ name: "Quantity", message: this.localizer.get("Store.Cart.Error_QuantityNotValid") });
        } else {
            try {
                await Axios.post(this.routes.StoreCart_AddProduct, { productIdMaster: this.product.idMaster, productQuantity: this.quantity, additionalInfo: this.additionalInfo });

                await this.getCart();

                this.$store.commit("cartStore/setIsCartPreviewShow", true);

                GTagHelper.sendCustomEvent("add_to_cart", {
                    currency: "EUR",
                    value: (this.product.discountPrice ? this.product.discountPrice : this.product.price) * this.quantity,
                    items: [
                        {
                            item_id: this.product.code,
                            item_name: this.product.title,
                            affiliation: "ML Engraving",
                            currency: "EUR",
                            item_category: this.product.categoryName,
                            price: this.product.price,
                            discount: this.product.discountPrice ? this.product.price - this.product.discountPrice : 0,
                            quantity: this.quantity
                        }
                    ]
                });
            } catch (error) {
                if (error.response && error.response.status === 400) {
                    this.validationErrors = FormHelper.getValidationErrors(error.response.data);
                }
            }
        }

        this.isLoading = false;
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
};